
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ListViewModel } from '@/definitions/view-models';
import { Debounce } from '@/common/debounce-decorator';
import NButton from '@/uikit/buttons/NButton.vue';
import { websocketModule } from '@/store/ws/websocket.module';
import { Camera } from '@/api';

type OneItem = {
  params: any;
  count: number;
};

type AllItems = Record<string, OneItem>;

@Options({
  name: 'CameraStatistics',
  components: { NButton }
})
export default class CameraStatistics extends Vue {
  @Prop({ type: Object, required: true })
  module!: ListViewModel<any, any>;

  items: AllItems = {
    total: {
      params: {},
      count: 0
    },
    withProblem: {
      params: { state_color: 'yellow' },
      count: 0
    },
    doesntWork: {
      params: { state_color: 'red' },
      count: 0
    }
  };

  async loadItem(item: OneItem) {
    try {
      const newFilter = { ...this.module.filter.final, ...item.params };
      const responseData = await this.module.dataService.getStatistics(newFilter);
      item.count = responseData.count;
    } catch (e) {
      item.count = 0;
    }
  }

  @Debounce(300)
  loadAllItems() {
    this.loadItem(this.items.total);
    this.loadItem(this.items.withProblem);
    this.loadItem(this.items.doesntWork);
  }

  async created() {
    await this.loadAllItems();
  }

  @Watch('module.loading')
  async changeModuleNameHandler(v: boolean) {
    if (v) await this.loadAllItems();
  }

  setItem(item: OneItem) {
    Object.assign(this.module.filter.current, item.params);
  }

  get websocketModule() {
    return websocketModule;
  }

  @Watch('websocketModule.cameraUpdated')
  @Debounce(10000)
  updateCamera(updatedItem: Camera) {
    this.loadAllItems();
  }
}
